module.exports = __webpack_public_path__ + "img/aadd595.png";